// import api from 'axios';
import api from "./../api";

import moment from "moment";
import Swal from "sweetalert2";
import UtilsUrl from "../../utils/UtilsUrl";

const insertContract = (formData) => {
  // Convert date format to 'YYYY-MM-DD'
  // const { date_deb, date_fin, ...otherFormData } = formData;
  // const formattedFormData = {
  //   ...otherFormData,
  //   date_deb: moment(formData.date_deb).format('YYYY-MM-DD'),
  //   date_fin: moment(formData.date_fin).format('YYYY-MM-DD'),

  // };
  // console.log(formattedFormData)
  return api.post(UtilsUrl.rhURL() + "/contracts/add_contract", formData);
};
const getEmployeEmail = async (employeeId) => {
  return api
    .get(UtilsUrl.rhURL() + `/employees/${employeeId}`)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
const getEmployeCin = async (employeeId) => {
  return api.get(
    UtilsUrl.rhURL() + `/employees/employeesCinById/${employeeId}`
  );
};
const getEmployeesCinById = (idUser) => {
  return api.get(UtilsUrl.rhURL() + "/employees/employeesCinById/" + idUser);
};
const getEmployeesNames = (idUser) => {
  return api.get(UtilsUrl.rhURL() + "/employees/No_Contract/" + idUser);
};
const getPostNames = (idUser) => {
  return api.get(UtilsUrl.rhURL() + "/postes/" + idUser);
};
const getContractTypeNames = (idUser) => {
  return api.get(UtilsUrl.rhURL() + "/contract_types/" + idUser);
};
const getAllContracts = (idUser) => {
  return api.get(UtilsUrl.rhURL() + "/contracts/" + idUser);
};
const checkIfEmployeeHasContract = (idEmployee) => {
  return api.get(UtilsUrl.rhURL() + `/contracts/hasContract/${idEmployee}`);
};

const getContractInfoById = async (idContract) => {
  return await api.get(
    UtilsUrl.rhURL() + `/contracts/contractInfoById/${idContract}`
  );
};

const getSocieteByUser = async (idUser) => {
  return await api.get(
    UtilsUrl.rhURL() + `/employees/getSocieteByUser/${idUser}`
  );
};

const updateContract = async (id, contract) => {
  return await api.put(
    UtilsUrl.rhURL() + `/contracts/updateContract/${id}`,
    contract
  );
};
const deleteContract = async (contractID, setContracts) => {
  try {
    const result = await Swal.fire({
      title: "Es-tu sûr?",
      text: "Vous ne pourrez pas annuler cette action !",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Oui, supprimez-le !",
      cancelButtonText: "Non, annulez !",
      reverseButtons: true,
    });

    if (result.isConfirmed) {
      await api.put(
        UtilsUrl.rhURL() + `/contracts/archiveContract/${contractID}`,
        {
          isDeleted: true,
        }
      );

      Swal.fire("Supprimé !", "Contrat archiver avec succès.", "success");

      setContracts((prevState) =>
        prevState.filter((contract) => contract.idContract !== contractID)
      );
    } else if (result.dismiss === Swal.DismissReason.cancel) {
      Swal.fire("Cancelled", "Your file is safe :)", "error");
    }
  } catch (error) {
    console.error(error);
  }
};
const isExistContract = async (idUser) => {
  return await api.get(UtilsUrl.rhURL() + `/contracts/isExist/${idUser}`);
};
export {
  getEmployeesCinById,
  insertContract,
  getEmployeEmail,
  getEmployeesNames,
  checkIfEmployeeHasContract,
  getPostNames,
  getContractTypeNames,
  getAllContracts,
  getContractInfoById,
  updateContract,
  deleteContract,
  getEmployeCin,
  isExistContract,
 getSocieteByUser,
};
